// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1MfUg","col":"styles_col__3IOLu","actions":"styles_actions__12ks6","conflict":"styles_conflict__2HIwQ"};